import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { ProposalListingSearchHandler } from './proposal-listing-search.handler';

@Component({
  selector: 'sym-proposal-listing-search',
  templateUrl: './proposal-listing-search.component.html',
  styleUrls: ['./proposal-listing-search.component.scss'],
})
export class ProposalListingSearchComponent extends ProposalListingSearchHandler implements OnInit {
  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
